module.exports = __webpack_public_path__ + "static/img/tt_logo.bd2e67fc.png";